<template>
  <div class="section-category" style="position: relative;" ref="sectionCategory">
    <div class="corner-wrapper">
      <div class="corner" v-if="itemData.cornerMarkType">
        <span :class="{offset: itemData.cornerMarkType === 1}">{{itemData.cornerMarkType === 1 ? 'NEW' : '上新'}}</span>
      </div>
    </div>
    <div
      v-if="itemData.isCommerical"
      class="commerical"
    >
      <!-- 会员可商用 -->
    </div>
    <section
      class="sectionCategory"
      ref="section"
      @click="
        sectionClick($event)
      "
    >
      <el-tooltip effect="dark" content="点击可展开/收起" placement="left" :open-delay="1000">
        <img :src="$handleAssetsUrl(itemData.iconUrl)" width="auto" height="100%">
      </el-tooltip>

      <span>{{itemData.name}}</span>

    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyLabel from '../../../widgets/label'

export default {
  name : 'sectionCategory',
  components: {
    MyLabel
  },
  props: ['itemData', 'itemIndex', 'boxName'],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'UserEquity',
    ])
  },
  watch: {

  },
  mounted () {

  },
  methods: {
    sectionClick(ev){
      this.$emit('click');
      this.$emit('scrollTop', this.itemIndex);
      this.$emit('getData', this.itemData.id);
      this.$emit('dataBoxAction', '_' + this.itemData.id);
      const h = () => {
        this.$bus.off('rightnavSlide.getDataDone', h);
        setTimeout(() => {
          const $el = $(this.$parent.$parent.$el).find('.sectionCategory:visible').eq(this.itemIndex);
          const innerRect = $el[0].getBoundingClientRect();
          const wrapperRect = this.$parent.$parent.$el.getBoundingClientRect();
          let delta = innerRect.top - wrapperRect.top;
          let top = this.$parent.$parent.$el.scrollTop += delta;
          this.$parent.scollTop.scollTop = top;

          // this.$emit('dataBoxAction', '_' + this.itemData.id);
        }, 120);
      };
      this.$bus.on('rightnavSlide.getDataDone', h);
      this.$bus.emit('rightNav.sectionClicked');
    }
  }
}
</script>

<style lang="scss" scoped>
  .sectionCategory{
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 9px;
    background: #fff;
    // position: relative;
    overflow: hidden;

    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      margin-bottom: 15px;
      border-radius: 8px;
      cursor: pointer;
    }
    .expand-line {
      width: 270px;
      height: 16px;
      background-color: #ccc;
    }
  }
  .commerical{
    position: absolute;
    // top: 14px;
    // right: -19px;
    // width: 127px;
    // height: 20px;
    // background-image: linear-gradient(-90deg, #e3a995 0%, #fffbed 100%);
    // box-shadow: 0px 0px 8px 0px rgba(42, 46, 70, 0.43);
    // transform: rotate(35deg);
    font-size: 12px;
    line-height: 20px;
    color: #010101;
    padding-left: 15px;
    width: 36px;
    height: 36px;
    background-image: url(../../../../../static/svg/commerce-tag.svg);
    background-repeat: no-repeat;
    top: -12px;
    right: 1px;
  }
  .corner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
    pointer-events: none;
  }
  .corner {
    position: absolute;
    background-color: #ff4049;
    top: 0;
    left: 0;
    width: 80px;
    height: 40px;
    transform-origin: 0 100%;
    transform: rotate(-45deg);
    & > span {
      position: absolute;
      bottom: 0px;
      left: 13px;
      transform: scale(0.7);
      color: #fff;
      &.offset {
        left: 10.5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/sectionCategory.vue